<template>
  <div>
    <div class="wrapper">
      <div class="content">
        <div class="title">￥200</div>
        <div class="time">水果类满1000可用</div>
      </div>
      <div class="split-line"></div>
      <div class="tip">
        <div class="tip-btn">
          点击
          <br />领取
        </div>
        <div class="tip-btn-bd"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
/* 优惠卷 */

::webkit-scrollbar {
    display: none;
}
.coupons {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  margin: 10px 20px 10px 0;
}
.wrapper {
  width: 230px;
  display: flex;
  border-radius: 8px;
  /* margin: 0 20px 20px 0; */
}
.content {
  flex: 1;
  padding: 10px;
  border-radius: 8px 0 0 8px;
  background: rgba(116, 180, 43, 0.2);
  border: 1px dashed rgba(116, 180, 43, 1);
  border-right: 0px;
}
.title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 20px;
}
.time {
  margin-top: 6px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.tip {
  position: relative;
  flex: 0 0 80px;
  text-align: center;
  border-radius: 0 8px 8px 0;
  background: #fff;
  margin-right: 20px;
}
.split-line {
  position: relative;
  flex: 0 0 0;
  border-left: 1px dashed #74b42b;
  background: rgba(116, 180, 43, 0.2);
}
.split-line:before,
.split-line:after {
  content: "";
  position: absolute;
  width: 16px;
  height: 8px;
  background: #fff;
  border: 1px dashed rgba(116, 180, 43, 1);

  left: -9px;
  z-index: 1;
}
.split-line:before {
  border-top: 0px;
}
.split-line:after {
  border-bottom: 0px;
}
.split-line:before {
  border-radius: 0 0 8px 8px;
  top: 0;
}
.split-line:after {
  border-radius: 8px 8px 0 0;
  bottom: 0;
}
.tip {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed rgba(116, 180, 43, 1);
  border-left: 0;
  background: rgba(116, 180, 43, 0.2);
  position: relative;
}
.tip-btn {
  width: 30px;
  height: 30px;
  padding: 5px;
  background: rgba(126, 211, 33, 1);
  border-radius: 50%;
  font-size: 8px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tip-btn-bd {
  position: absolute;
  width: 45px;
  height: 45px;
  border: 2px dashed #7ed321;
  border-radius: 50%;
}
</style>